import { render, staticRenderFns } from "./header-parallax.vue?vue&type=template&id=a0823aec&"
import script from "./header-parallax.vue?vue&type=script&lang=js&"
export * from "./header-parallax.vue?vue&type=script&lang=js&"
import style0 from "./header-parallax.vue?vue&type=style&index=0&id=a0823aec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports